import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { configData } from "../config";

const ViewSuccessStoryPage = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [detailedview, setDetailedView] = useState({});
    var {tab} = useParams();
    const app_url = configData.APP_URL;
    const {sid} = useParams();

    useEffect(() => {
        Promise.all([
            retrieveSuccessStory()
        ]).then(() => {
            setIsLoading(false);
        })
    },[]);

    async function retrieveSuccessStory() {
        const response = await fetch(
        app_url+'smwwagency/retrieveagentmessage?id='+sid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            setDetailedView(
                {
                   body: responsedata.data.result.editbody
                }
            );
        }
    }

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div>
                    <div className="view-agent-msg-container">
                        <div dangerouslySetInnerHTML={{ __html: detailedview.body }} />
                    </div>
                </div>
            )}
        </>
    );
};
export default ViewSuccessStoryPage;